import React from 'react';

export default function ConditionalRender({
  condition,
  children,
  fallBack
}: {
  condition: boolean;
  children: React.ReactNode;
  fallBack?: React.ReactNode;
}) {
  if (condition) {
    return children;
  } else {
    return fallBack || '';
  }
}
